import { useAuthStore } from '@/modules/core/stores/auth.store.ts';
import { useUserStore } from '@/modules/core/stores/user.store.ts';
import { useSyncSystemStore } from '@/modules/core/stores/sync-system.store.ts';
import { useRolesStore } from '@/modules/core/stores/roles.store.ts';
import { useAccessStore } from '@/modules/core/stores/access.store.ts';
import { useCacheStore } from '@/modules/core/stores/cache.store.ts';
import { usePreviewStore } from '@/modules/core/stores/preview.store.ts';
import { useNotificationTimerStore } from '@/modules/common/stores/notification-timer.ts';
import { queryClient } from '@/tanstack-query.ts';
import { resetFeatureState } from '@/modules/shared/utils/app-reset.util.ts';

export class AppUtil {
  static clear(clearAuth = true) {
    if (clearAuth) {
      [useAuthStore(), useUserStore(), useSyncSystemStore(), useRolesStore(), useAccessStore()].forEach((store) =>
        store.$reset(),
      );
    }

    [
      useCacheStore(),
      usePreviewStore(),
      useNotificationTimerStore(),
    ].forEach((store) => store.$reset());

    resetFeatureState();

    void queryClient.cancelQueries();
    queryClient.clear();
  }
}
